<template lang="pug">
v-card.mt-2(color='white' light)
  .payment-bar.fancy.small(:class='barClass')
  v-card-text.payment
    .label.grey--text.text--darken-2(v-if='payment === null') 報名人尚未取得繳費資訊
    //- 只有在已繳費時顯示
    v-layout(row wrap v-if='isPaid')
      v-flex(xs12 v-if='payment.tradeAmt || payment.tradeAmt === 0')
        h2 NT$ {{ payment.tradeAmt }}
    v-layout(row wrap v-for='key in paymentKeyOrder' v-if='getIsFieldExist(key) && isRowShow(key)' :key='key')
      v-flex(xs3): .label.grey--text.text--darken-2 {{ paymentKeyTable[key] }}
      v-flex(xs9)
        //- 狀態
        template(v-if='key === `rtnCode`')
          b.value(:class='rtnCodeTable[payment[key]].class') {{ rtnCodeTable[payment[key]].name }}
          span.grey--text.text--darken-2(v-if='isManualBill') (手動設定)
        //- 銀行代碼
        .value(v-else-if='key === `bankCode`')
          | {{ payment[key] }}
          span.grey--text.text--darken-2  ({{ convertBankCode(payment[key]) }})
        .value(v-else-if='key === `vAccount`')
          | {{ payment[key] }}
          v-tooltip(right)
            v-btn.ma-0(small icon flat :ripple='false' slot='activator'): v-icon(small color='grey') fas fa-question-circle
            span 報名人應匯款至的帳號
        //- 日期類
        .value(v-else-if='getIsDateField(key)') {{ payment[key] | time }}
        //- 其餘的
        .value(v-else) {{ payment[key] }}
    small.logo #[b 樂台計畫]金流服務
</template>

<script>
export default {
  name: 'PaymentCard',
  props: {
    payment: {
      type: Object,
      default: null,
    },
    isManualBill: {
      default: null,
    },
  },
  methods: {
    getIsDateField (key) {
      return ['paymentDate', 'expireDate'].some(_ => key === _)
    },
    getIsFieldExist (key) {
      return this.payment && this.payment[key] !== undefined
    },

    isRowShow (key) {
      return !(key === 'tradeAmt' && this.isPaid)
    },
  },
  computed: {
    isFree () {
      return this.payment && +this.payment.tradeAmt === 0
    },
    barClass () {
      return { manual: this.isManualBill }
    },
    isPaid () {
      const _ = this.payment
      return (_ && _.rtnCode && +_.rtnCode === 1)
    },
  },
}
</script>

<style scoped lang="sass">
.payment
  .label
    font-size: .9rem
  .value
    font-family: $monospace
  .logo
    position: absolute
    right: .5rem
    bottom: .3rem
    opacity: .5
    user-select: none
    font-style: italic
</style>
